import { render, staticRenderFns } from "./CompanyLinks.vue?vue&type=template&id=3b74e12a&scoped=true"
import script from "./CompanyLinks.vue?vue&type=script&lang=js"
export * from "./CompanyLinks.vue?vue&type=script&lang=js"
import style0 from "./CompanyLinks.vue?vue&type=style&index=0&id=3b74e12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74e12a",
  null
  
)

export default component.exports